(function () {
  'use strict';

  angular
    .module('renewals')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('renewals', {
        url: '/renewals',
        views : {
        	renewalsView : {
        		  templateUrl: 'renewals/views/renewals.tpl.html',
        	      controller: 'RenewalsCtrl',
        	      controllerAs: 'renewals'
        	}
        }
      });
  }
}());
